import React from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Select from 'react-select';

const AddCharge = ({ showAdd, handleCloseAdd }) => {
    const CFSOptions = [
        { value: 1, label: "CFS 1" },
        { value: 2, label: "CFS 2" },
        { value: 3, label: "CFS 3" },
        { value: 4, label: "CFS 4" },
        { value: 5, label: "CFS 5" },
        { value: 6, label: "CFS 6" },
        { value: 7, label: "CFS 7" },
        { value: 8, label: "CFS 8" },
        { value: 9, label: "CFS 9" },
        { value: 10, label: "CFS 10" },
        { value: 11, label: "CFS 11" },
        { value: 12, label: "CFS 12" },
        { value: 13, label: "CFS 13" },
        { value: 14, label: "CFS 14" },
        { value: 15, label: "CFS 15" },
        { value: 16, label: "CFS 16" },
        { value: 17, label: "CFS 17" },
        { value: 18, label: "CFS 18" },
        { value: 19, label: "CFS 19" },
        { value: 20, label: "CFS 20" }
    ];
    return (
        <>
            <Offcanvas show={showAdd} onHide={handleCloseAdd} placement={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Charge</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="row">
                        {/* Description */}
                        <div className="col-md-12 mt-2">
                            <label htmlFor="service" className="form-label text-label-red">
                                Service
                            </label>
                            <select className="form-control form-control-sm" id="service">
                                <option value="Freight">Freight</option>
                                <option value="Customs">Customs</option>
                                <option value="General Job">General Job</option>
                            </select>
                        </div>
                        {/* Packages */}
                        <div className="col-md-6 mt-2">
                            <label htmlFor="packages" className="form-label text-label-red">
                                Charge
                            </label>
                            <Select
                                id="DestinationAgent"
                                placeholder="Select Organisation"
                                className='mt-2 custom-selector w-100'
                                options={CFSOptions}
                                name="role_id"
                            />
                        </div>
                        {/* Inner Packages */}
                        <div className="col-md-6 mt-2">
                            <label htmlFor="inner_packages" className="form-label text-label-red">
                                Category
                            </label>
                            <input type="number" className="form-control form-control-sm" id="inner_packages" value={"cost"} />
                        </div>
                        {/* Gross Weight */}
                        <div className="col-md-6 mt-2">
                            <label htmlFor="gross_weight" className="form-label text-label-red">
                                Type
                            </label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="gross_weight"
                                step="0.001"
                                value="Commission"
                            />
                        </div>
                        {/* Net Weight */}

                        <div className="row my-3">
                            <h4>Revenues</h4>
                        </div>

                        <div className="col-md-12 mt-2">
                            <label htmlFor="chargeDescription" className="form-label text-label-red">Charge Description</label>
                            <textarea type="text" name="chargeDescription" id="chargeDescription" className='form-control' rows={3} ></textarea>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="prepaidCollect" className="form-label text-label-red">Prepaid/Collect</label>
                            <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >Prepaid</option>
                                <option value="Collection" >Collection</option>
                            </select>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="overrideAutoRate" className="form-label text-label-red">Override Auto Rate</label>
                            <input type="text" name="overrideAutoRate" id="overrideAutoRate" className='form-control form-control-sm' />

                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="basis" className="form-label text-label-red">Basis (In Kg)</label>
                            <select className='form-control form-control-sm' id="basis" >
                                <option selected> Per Package </option>
                                <option> By Gross Wt </option>
                                <option> By Chg Wt </option>
                                <option> By Volume </option>
                                <option> % of Freight </option>
                                <option> % of Oth Chrgs. </option>
                                <option> Per Vehicle </option>
                                <option> By Net Wt </option>
                                <option> By Volume Wt </option>
                                <option> Per BL/AWB/Doc </option>
                                <option> Custom </option>
                                <option> Container </option>
                                <option> Per Hour </option>
                                <option> Per Labour - Per Day </option>
                            </select>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="dueTo" className="form-label text-label-red">Due To</label>
                            <select className='form-control form-control-sm' id="basis" >
                                <option selected> Airline </option>
                                <option> Origin Agent </option>
                                <option> Destination Agent </option>
                            </select>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="qtyUnit" className="form-label text-label-red">Quantity/Unit</label>
                            <input type="number" name="qtyUnit" id="qtyUnit" className='form-control form-control-sm' />
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="receivableType" className="form-label text-label-red">Receivable Type</label>
                            <select className='form-control form-control-sm' id="receivableType" >
                                <option value="Shipper" selected >Shipper</option>
                                <option value="Carrier/GSA" >Carrier/GSA</option>
                                <option value="Other Entity" >Other Entity</option>
                            </select>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="rate" className="form-label text-label-red">Rate</label>
                            <input type="number" name="rate" id="rate" className='form-control form-control-sm' />
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="amount" className="form-label text-label-red">Amount</label>
                            <input type="number" name="amount" id="amount" className='form-control form-control-sm' />
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="amountHC" className="form-label text-label-red">Amount (HC)</label>
                            <input type="number" name="amountHC" id="amountHC" className='form-control form-control-sm' />
                        </div>



                        <div className="col-md-6 mt-2">
                            <input type="checkbox" name="copyToCost" id="copyToCost" className='me-2' />
                            <label htmlFor="copyToCost" className="form-label text-label-red">Copy to Cost</label>
                        </div>


                        <div className="row my-3">
                            <h4>Cost</h4>
                        </div>

                        <div className="col-md-12 mt-2">
                            <label htmlFor="chargeDescription" className="form-label text-label-red">Charge Description</label>
                            <textarea type="text" name="chargeDescription" id="chargeDescription" className='form-control' rows={3} ></textarea>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="prepaidCollect" className="form-label text-label-red">Prepaid/Collect</label>
                            <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >Prepaid</option>
                                <option value="Collection" >Collection</option>
                            </select>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="overrideAutoRate" className="form-label text-label-red">Override Auto Rate</label>
                            <input type="text" name="overrideAutoRate" id="overrideAutoRate" className='form-control form-control-sm' />

                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="basis" className="form-label text-label-red">Basis (In Kg)</label>
                            <select className='form-control form-control-sm' id="basis" >
                                <option selected> Per Package </option>
                                <option> By Gross Wt </option>
                                <option> By Chg Wt </option>
                                <option> By Volume </option>
                                <option> % of Freight </option>
                                <option> % of Oth Chrgs. </option>
                                <option> Per Vehicle </option>
                                <option> By Net Wt </option>
                                <option> By Volume Wt </option>
                                <option> Per BL/AWB/Doc </option>
                                <option> Custom </option>
                                <option> Container </option>
                                <option> Per Hour </option>
                                <option> Per Labour - Per Day </option>
                            </select>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="dueTo" className="form-label text-label-red">Due To</label>
                            <select className='form-control form-control-sm' id="basis" >
                                <option selected> Airline </option>
                                <option> Origin Agent </option>
                                <option> Destination Agent </option>
                            </select>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="qtyUnit" className="form-label text-label-red">Quantity/Unit</label>
                            <input type="number" name="qtyUnit" id="qtyUnit" className='form-control form-control-sm' />
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="receivableType" className="form-label text-label-red">AWB/ Print </label>
                            <select className='form-control form-control-sm' id="receivableType" >
                                <option value="Print with Freight" selected >Print with Freight</option>
                                <option value="Carrier/GSA" >Carrier/GSA</option>
                                <option value="Other Entity" >Other Entity</option>
                            </select>
                        </div>
                        
                        <div className="col-md-6 mt-2">
                            <label htmlFor="rate" className="form-label text-label-red">Rate</label>
                            <input type="number" name="rate" id="rate" className='form-control form-control-sm' />
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="receivableType" className="form-label text-label-red">Payable Type </label>
                            <select className='form-control form-control-sm' id="receivableType" >
                                <option value="Print with Freight" selected >Print with Freight</option>
                                <option value="Carrier/GSA" >Carrier/GSA</option>
                                <option value="Other Entity" >Other Entity</option>
                            </select>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="amount" className="form-label text-label-red">Amount</label>
                            <input type="number" name="amount" id="amount" className='form-control form-control-sm' />
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="receivableType" className="form-label text-label-red">Payable To </label>
                            <select className='form-control form-control-sm' id="receivableType" >
                                <option value="Print with Freight" selected >Print with Freight</option>
                                <option value="Carrier/GSA" >Carrier/GSA</option>
                                <option value="Other Entity" >Other Entity</option>
                            </select>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label htmlFor="amountHC" className="form-label text-label-red">Amount (HC)</label>
                            <input type="number" name="amountHC" id="amountHC" className='form-control form-control-sm' />
                        </div>



                        <div className="col-md-6 mt-2">
                            <input type="checkbox" name="copyToCost" id="copyToCost" className='me-2' />
                            <label htmlFor="copyToCost" className="form-label text-label-red">Copy to Cost</label>
                        </div>
                    </div>


                    <div className="row justify-content-end mt-3 gap-2">
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save
                        </button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas >
        </>
    )
}

export default AddCharge